<template>
  <b-modal
    v-model="isOpen"
    centered
    hide-header
    hide-footer
    :width="500"
    content-class="upgrade-modal"
    @close="closeModal()"
  >
    <div class="p-5 upgrade-container text-center">
      <div class="rocket-circle">
        <span class="material-symbols-outlined rocket-icon">rocket_launch</span>
      </div>
      <h3 class="upgrade-title">Ready for Takeoff?</h3>
      <p class="upgrade-description">
        Discover premium features that help you create faster, sell better, and
        impress every passenger.
      </p>
      <div class="features-wrapper">
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="feature-item d-flex align-items-center"
        >
          <div class="feature-icon-box">
            <span class="material-symbols-outlined feature-icon">
              {{ feature.icon }}
            </span>
          </div>
          <span class="feature-text">
            {{ feature.text }}
          </span>
        </div>
      </div>
      <b-button block class="upgrade-btn" @click="goToPro">
        <strong>UPGRADE MY PLAN</strong>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import BaseButton from "@/components/base-ui/BaseButton.vue";

export default {
  name: "ProFeatureModal",
  components: { BaseButton },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
    goToPro: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isOpen: this.isModalOpen,
      features: [
        { icon: "bolt", text: "Create faster with AI-tools" },
        { icon: "trending_up", text: "Sell better with analytics" },
        { icon: "star", text: "Impress every passenger" },
      ],
    };
  },
  watch: {
    isModalOpen(newValue) {
      this.isOpen = newValue;
    },
  },
  mounted() {
    this.loadMaterialIcons();
  },
  methods: {
    loadMaterialIcons() {
      if (!document.getElementById("material-icons-font")) {
        const link = document.createElement("link");
        link.id = "material-icons-font";
        link.rel = "stylesheet";
        link.href =
          "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";
        document.head.appendChild(link);
      }
    },
  },
};
</script>

<style scoped>
.upgrade-modal {
  border-radius: 18px;
  padding: 25px 20px 30px;
  background: #f3f4f6;
  border: none;
}

.upgrade-container {
  margin: auto;
  background-color: #efefef;
}

.rocket-circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #ff7a00;
  background: rgba(255, 122, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
}

.rocket-icon {
  font-size: 30px;
  color: #ff7a00;
}

.upgrade-title {
  font-weight: 700;
  font-size: 24px;
  color: #0f172a;
  margin-bottom: 15px;
}

.upgrade-description {
  font-size: 15px;
  color: #475569;
  margin-bottom: 30px;
  line-height: 1.6;
}

.features-wrapper {
  margin-bottom: 35px;
}

.feature-item {
  background: white;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 14px;
}

.feature-icon-box {
  width: 36px;
  height: 36px;
  background: #d1d5db;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
}

.feature-icon {
  font-size: 18px;
  color: #475569;
}

.feature-text {
  font-weight: 500;
  color: #0f172a;
}

.upgrade-btn {
  padding: 25px;
  width: 100%;
  background: rgb(249 115 22);
  border: none;
  border-radius: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 15px;
  transition: 0.25s ease;
  color: white;
  box-shadow: 0 8px 20px rgba(255, 106, 0, 0.35);
}

.upgrade-btn:hover {
  color: white;
  background: rgb(234 88 12);
}
</style>
